export const ChangeFontFace = lang => {
    let style = document.getElementById('global-font-style')
    if (!style) {
        style = document.createElement('style')
        style.id = 'global-font-style'
        document.head.appendChild(style)
    }

    switch (lang) {
        case 'jp':
            style.innerText = `
                * {
                    font-family: 'Meiryo-custom', sans-serif ;
                    letter-spacing: -1.25px;
                }
            `
            break

        case 'en':
            style.innerText = `
                * {
                    font-family: 'Tahoma-custom', sans-serif ;
                    letter-spacing: -0.4px;
                }
            `
            break
        
        default:
            style.innerText = `
                * {
                    font-family: 'Noto Sans CJK KR', sans-serif ;
                    letter-spacing: -1px;
                }
            `
            break
    }
}